<template>
    <div class="container">
        <div class="colored-box" :style="{ backgroundColor: boxColor }" @click="$emit('click')"></div>
        <span class="number">{{ number }}</span>
    </div>
</template>

<script>export default {
  name: 'ColoredBoxWithNumber',
  props: {
    number: {
      type: Number,
      required: true
    },
    boxColor: {
      type: String,
      required: true
    }
  }
}</script>

<style scoped>
    .container {
        display: flex;
        align-items: center;
    }

    .colored-box {
        width: 80px;
        height: 20px;
        margin-right: 10px;
    }

    .number {
        font-size: 14px;
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/ColoredBox.vue